<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/Packet' }">分组管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item v-else :to="{ path: '/iot/terminal' }">终端管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/PacketData',query: {id: $route.query.Packet,name: $route.query.name }}">设备信息</el-breadcrumb-item>
						<el-breadcrumb-item v-else :to="{ path: '/iot/sensor',query: {id: $store.state.Iot.devicesdata1.id,name: $route.query.name }}">设备信息</el-breadcrumb-item>
						<el-breadcrumb-item>数据同比</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row class="top">
			<el-col :md="7">
				<div class="block s-block">
					<span class="demonstration">参考年份：</span>
					<el-date-picker
					:size="$store.state.width<$store.state.minwidth?'mini':''"
					v-model="value1"
					type="year"
					placeholder="请选择年份">
					</el-date-picker>
				</div>
				<div class="block">
					<span class="demonstration">对比年份：</span>
					<el-date-picker
					:size="$store.state.width<$store.state.minwidth?'mini':''"
					v-model="value2"
					type="year"
					placeholder="请选择年份">
					</el-date-picker>
				</div>
			</el-col>
			<el-col :md="17">
				<div class="kuai">
					<span>10-01</span>
					<span class="time">12-31</span><br>
					<el-button type="primary" class="chun" @click="find(3)">冬季</el-button>
				</div>
				<div class="kuai">
					<span>07-01</span>
					<span class="time">09-30</span><br>
					<el-button type="warning" class="chun" @click="find(2)">秋季</el-button>
				</div>
				<div class="kuai">
					<span>04-01</span>
					<span class="time">06-30</span><br>
					<el-button type="danger" class="chun" @click="find(1)">夏季</el-button>
				</div>
				<div class="kuai">
					<span>01-01</span>
					<span class="time">03-31</span><br>
					<el-button type="success" class="chun" @click="find(0)">春季</el-button>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="shidu">
					<div class="quxian" id="myChart" v-loading="myload.load"></div>
				</div>
			</el-col>
		</el-row>
    </div>
</template>
<script>
	export default {
		data() {
			return {
				myload: {
					load: false,
					num: false
				},
				value1: new Date((Number(this.Totime(new Date().getTime()/1000).split('-')[0])-1)+'/01/01 00:00:00'),
				value2: new Date(),
				data1: [],
				data2: [],
				Content: {
					maxContent: null,
					minContent: null
				},
				jij: '',
				sonser: null,
				jijtime: [
					{
						start: '01/01',
						end: '03/31'
					},
					{
						start: '04/01',
						end: '06/31'
					},
					{
						start: '07/01',
						end: '09/31'
					},
					{
						start: '10/01',
						end: '12/31'
					}
				]
			};
		},
		mounted(){
			this.load();
		},
		methods: {
			drawLine(){
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('myChart'));
				var unit=this.$store.state.Iot.device.unit!=0?"("+this.$store.state.Iot.device.unit+")":"";
				// 绘制图表
				myChart.setOption({
					title: { text: this.$store.state.Iot.device.description+"("+this.jij+")"+unit },
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category'
					},
					legend: {
						data:[this.Totime(this.value2.getTime()/1000).split('-')[0]+"年",this.Totime(this.value1.getTime()/1000).split('-')[0]+"年"],
						x: "right"
					},
					grid: {
						left: '2%',
						right: '60px',
						containLabel: true
					},
					yAxis: {
						max: this.Content.maxContent,
						min: this.Content.minContent,
						type: 'value'
					},
					series: [
						{
							name: this.Totime(this.value1.getTime()/1000).split('-')[0]+"年",
							smooth: true,
							type: 'line',
							data: this.data1
						},
						{
							name: this.Totime(this.value2.getTime()/1000).split('-')[0]+"年",
							smooth: true,
							type: 'line',
							data: this.data2
						},
					],
					dataZoom: [{
							type: 'slider',
							xAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'slider',
							yAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'inside',
							xAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'inside',
							yAxisIndex: 0,
							filterMode: 'none'
						}
					]
				});
			},
			load()
			{
				this.getSonser();
			},
			getSonser()
			{
				let value={
					id: this.$route.query.id
				};
				this.$store.commit('mainload',true);
				this.getdevice(value)
				.then((response)=>{
					if(response.data.code==1)
					{
						for(var i=0;i<this.jijtime.length;i++)
						{
							if(new Date(this.Totime(new Date().getTime()/1000).split('-')[0]+'/'+this.jijtime[i].start+' 00:00:00').getTime()<new Date().getTime()&&new Date(this.Totime(new Date().getTime()/1000).split('-')[0]+'/'+this.jijtime[i].end+' 23:59:59').getTime()>=new Date().getTime())
							{
								this.find(i);
								return;
							}
						}
					}
				});
			},
			find(id)
			{
				switch(id)
				{
					case 0: this.jij="春季";break;
					case 1: this.jij="夏季";break;
					case 2: this.jij="秋季";break;
					case 3: this.jij="冬季";break;
				}
				var start=this.jijtime[id].start;
				var end=this.jijtime[id].end;
				if(this.value1==''||this.value2=='')
				{
					this.$message({message: '请选择年份！', type: 'warning' });
					return;
				}
				if(this.value1.getFullYear()==this.value2.getFullYear())
				{
					this.$message({message: '请选择不同年份！', type: 'warning' });
					return;
				}
				this.myload.load=true;
				this.myload.num=false;
				this.data1=[];
				this.data2=[];
				let value1={
					devices_id: this.$route.query.id,
					start_time: new Date(this.Totime(this.value1.getTime()/1000).split('-')[0]+'/'+start+' 00:00:00').getTime()/1000,
					end_time: new Date(this.Totime(this.value1.getTime()/1000).split('-')[0]+'/'+end+' 23:59:59').getTime()/1000,
					order: "updatetime asc"
				};
				this.getdevicesdata1(value1)
				.then((response)=>{
					if(response.data.code==1)
					{
						if(!this.myload.num)
						{
							this.Content.minContent=Number(response.data.data.minContent);
							this.Content.maxContent=Number(response.data.data.maxContent);
						}
						else{
							this.Content.minContent>Number(response.data.data.minContent)?(this.Content.minContent=Number(response.data.data.minContent)):"";
							this.Content.maxContent<Number(response.data.data.maxContent)?(this.Content.maxContent=Number(response.data.data.maxContent)):"";
						}
						for(var i=0;i<this.$store.state.Iot.devicesdata1.list.length;i++)
						{
							this.data1.push([
								this.Totime(this.$store.state.Iot.devicesdata1.list[i].createtime).substring(5),
								this.$store.state.Iot.devicesdata1.list[i].content
							]);
						}
						this.drawLine();
						this.$store.commit('mainload',this.myload.num?false:true);
						this.myload.load=this.myload.num?false:true;
						this.myload.num=true;
					}
				});
				let value2={
					devices_id: this.$route.query.id,
					start_time: new Date(this.Totime(this.value2.getTime()/1000).split('-')[0]+'/'+start+' 00:00:00').getTime()/1000,
					end_time: new Date(this.Totime(this.value2.getTime()/1000).split('-')[0]+'/'+end+' 23:59:59').getTime()/1000,
					order: "updatetime asc"
				};
				this.getdevicesdata2(value2)
				.then((response)=>{
					if(response.data.code==1)
					{
						if(!this.myload.num)
						{
							this.Content.minContent=Number(response.data.data.minContent);
							this.Content.maxContent=Number(response.data.data.maxContent);
						}
						else{
							this.Content.minContent>Number(response.data.data.minContent)?(this.Content.minContent=Number(response.data.data.minContent)):"";
							this.Content.maxContent<Number(response.data.data.maxContent)?(this.Content.maxContent=Number(response.data.data.maxContent)):"";
						}
						for(var i=0;i<this.$store.state.Iot.devicesdata2.list.length;i++)
						{
							this.data2.push([
								this.Totime(this.$store.state.Iot.devicesdata2.list[i].createtime).substring(5),
								this.$store.state.Iot.devicesdata2.list[i].content
							]);
						}
						this.drawLine();
						this.$store.commit('mainload',this.myload.num?false:true);
						this.myload.load=this.myload.num?false:true;
						this.myload.num=true;
					}
				});
			}
		}
    };
</script>
<style scoped>
	.quxian{
		width: 100%;
		height: 680px;
	}
	.shidu{
		margin-top: 10px;
		background-color: white;
	}
	.chun{
		width: 100%;
		max-width: 180px;
		height: 80px;
	}
	.zi1{
		color: #e6e6e6;
	}
	.sjtb{
		font-family:Hiragino Sans GB; 
	}
	.time{
		float: right;
	}
	.kuai{
		width: 20%;
		max-width: 180px;
		float: right;
		margin-left: 20px;
	}
	.title{
		text-align: center;
		margin-top: -10px;
	}
	.top{
		margin-top: 5px;
	}
	.s-block{
		margin-bottom: 16px;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			padding-left: 5px;
		}
		.kuai{
			margin-left: 1%;
			float: left;
			width: 24%;
			font-size: 12px;
		}
		.chun{
			height: 40px;
		}
		.block{
			margin-left: 5px;
			margin-bottom: 5px;
		}
		.shidu{
			margin: 5px;
		}
		.quxian{
			height: 400px;
		}
	}
</style>